import {Observable} from 'rxjs'
import {FileUploadErrorCause} from '../../../__generated__/types'

// This conforms to FileUploadRequest from the graphql API for simplicity
export interface FileUploadRequest {
  fileName: string
  contentType: string
  contentLength: number
}

export interface FileUploadLink {
  fileKey: string
  uploadLink: string
  downloadLink: string
}

export interface FileUploadError {
  message: string
  cause: FileUploadErrorCause
}

export type GenerateFileUploadLinkFunction = (file: FileUploadRequest) => Observable<FileUploadLink | FileUploadError>

export function isFileUploadError(res: FileUploadLink | FileUploadError): res is FileUploadError {
  return 'cause' in res
}
